import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { Delete } from '@material-ui/icons';
import Button from '../Button/Button';
import PopupWrapper from '../PopupWrapper';

const DeleteUser = props => {
  return (
    <PopupWrapper
      className="relative"
      isOpen={props.showDeleteWarningPopup === props.index}
      togglePopup={() => props.toggleDeleteWarningPopup(props.index)}>
      <Button
        type="transparent"
        className="p-0-important shadow-none-important h-6"
        onClick={() => props.toggleDeleteWarningPopup(props.index)}>
        <Delete className="text-darkGrey" />
      </Button>
      <AnimatePresence>
        {props.showDeleteWarningPopup === props.index && (
          <motion.div
            initial={{ opacity: 0, left: 0, top: 0, x: '-80%' }}
            animate={{ opacity: 1, x: '-100%' }}
            exit={{ opacity: 0, x: '-80%' }}
            transition={{
              ease: [0.18, 0.89, 0.39, 1.4],
              duration: 0.3,
            }}
            className="button-popup absolute pin-r px-2 py-4 bg-white shadow-md rounded text-left w-64 z-10">
            <div className="text-center leading-normal">
              {`Are you sure you want to delete user "${props.user.name}" ?`}
            </div>
            <div className="flex justify-around mt-8">
              <Button
                className="h-8"
                onClick={() => props.toggleDeleteWarningPopup(props.index)}>
                No
              </Button>
              <Button
                type="red-transparent"
                className="h-8"
                onClick={() => props.deleteUser(props.index)}>
                Yes, delete it
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </PopupWrapper>
  );
};

DeleteUser.propTypes = {
  index: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired,
  showDeleteWarningPopup: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
  toggleDeleteWarningPopup: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
};

export default  DeleteUser;
